import React from 'react';
import { SvgIcon } from '../svg-icon';

export const ArrowRight = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M10 17L15 12L10 7V17Z" />
  </SvgIcon>
);
